import React from "react";
import SponsorCard from "../../pages/Sponsors/Sponsor/SponsorCard";
import TimerBasic from "../../Timer/Timer";
import About from "../About/About";
import { FaFacebook, FaInstagram, FaYoutube, FaSnapchat } from "react-icons/fa";
import Contact from "../Contact/Contact";
import "./home.css";
import BlinkingLogo from "../../atrimages/event logo stroke.png";
import Guest from "../Guest/Guest";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <>
      <div class="HomeContainer">
        {/* <!-- Main Body Seciton --> */}
        <div className="bodycontainer">
          <h1 className="title">
            <img src={BlinkingLogo} alt="ATRI Events" />
          </h1>
          {/* <p className="subtitle">Rise to shine!</p> */}
          <p style={{ color: "white" }}>
            <TimerBasic />
          </p>
          <h3>
            <img src="" className="eventdate" alt="15th to 17th - JUNE 2023" />
          </h3>
          <Link
            to="register"
            className="eventreg-btn text-decoration-none animate__animated animate__headShake animate__infinite"
          >
            Register &gt;&gt;
          </Link>
          <h5 className="address-text">
            <a href="https://www.google.com/maps/place/Aurora%E2%80%99s+Technological+%26+Research+Institute/@17.3872898,78.5976687,14.67z/data=!4m14!1m7!3m6!1s0x3bcb99cd87dc821b:0x2b259ae251a6a65f!2sAurora%E2%80%99s+Technological+%26+Research+Institute!8m2!3d17.3889819!4d78.6037544!16s%2Fg%2F1wk6y6qx!3m5!1s0x3bcb99cd87dc821b:0x2b259ae251a6a65f!8m2!3d17.3889819!4d78.6037544!16s%2Fg%2F1wk6y6qx?entry=ttu">
              <i className="fa-solid fa-location-dot" target="_blank"></i>{" "}
              ATRI,Parvathapoor - Hyderabad
            </a>
          </h5>
          {/* <!-- <div className="location"><i className="fa-solid fa-location-dot"></i></i> ATRI Parvathapoor, Hyderabad</div> --> */}
          <div className="icon-container">
            <span>FOLLOW US ON: </span>
            <a href="https://www.facebook.com/atrihyd" target="_blank">
              <FaFacebook className="f" />
            </a>
            <a
              href="https://www.instagram.com/sacatriofficial/?hl=en"
              target="_blank"
            >
              <FaInstagram className="i" />
            </a>
            <a href="/" target="_blank">
              <FaYoutube className="y" />
            </a>
            <a href="/" target="_blank">
              <FaSnapchat className="s" />
            </a>
          </div>
        </div>
      </div>
      <About />
      <SponsorCard />
      <Guest />
      <Contact />
    </>
  );
}
